import _ from 'lodash';
import TagManager from 'react-server-side-gtm';
import { ENV, ENV_ENUM, GTM_KEY } from '@/shared/config';
import auth from '../auth/auth';

/**
 * Reports whether analytics tagging may run in this environment. Allows it only in the customer environment.
 *
 * @returns True in the customer environment.
 */
const isAllowedGtm = () => ENV === ENV_ENUM.customer;

/**
 * Boots Google Tag Manager with the signed-in user attached to the data layer. Uses the username, falling back to the user id when it is the literal string null, and points the customer environment at its own tag server and script directories before initializing.
 *
 * @returns Nothing.
 */
const initializeGtm = () => {
  const username = auth.username();
  const tagManagerArgs = {
    gtmId: GTM_KEY,
    dataLayer: {
      userId: username !== 'null' ? username : auth.userId(),
    },
  };
  if (ENV === ENV_ENUM.customer) {
    _.assign(tagManagerArgs, {
      src: 'https://ga.customer.biotricity.com',
      jsDir: 'js',
      htmlDir: 'html',
    });
  }
  TagManager.initialize(tagManagerArgs);
};

export { initializeGtm, isAllowedGtm };
